__webpack_require__.p = "/maelectricals/";